import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Tooltip } from "../../../../../revvComponents";

// Components Imports
import { Dropdown } from "../../../../../commonComponents";
import { preventEditorToDeactivate } from "../../../../../actions/DocumentActions/index";

// Internal Imports
import { COMMON } from "../../../../../constants";
import { GoogleSheetActions, QuotationActions } from "../../../../../actions";

// Destructuring
const { checkGSheetStoreForData } = GoogleSheetActions;
const { toggleTabAndToolPanelData } = QuotationActions;

const { TABLE_TYPE } = COMMON;

class QuoteTableViewBtn extends Component {
  componentDidMount = () => {
    document.addEventListener("mousedown", this._handleClick, false);
  };

  componentWillUnmount = () => {
    document.removeEventListener("mousedown", this._handleClick, false);
  };

  _handleClick = e => {
    if (
      this.node &&
      !this.node.contains(e.target) &&
      this.props.showQuoteViewDropdown
    ) {
      this.props.toggleDropdown(e, "QuoteView");
      this.props.preventEditorToDeactivate(false);
    }

    if (
      this.node &&
      this.node.contains(e.target) &&
      this.props.showQuoteViewDropdown
    ) {
      // prevent loosing editor focus when style/weight is selected
      this.props.preventEditorToDeactivate(true);
      e.preventDefault();
    }
  };

  _moveToLinkedGoogleSheet = section => {
    checkGSheetStoreForData(section.id);
    if (this.props.isLocked) {
      this.props.toggleTabAndToolPanelData({
        tabView: section.label,
        isOpen: false,
        panelView: "",
        page: TABLE_TYPE.GOOGLE_SHEET,
        tabViewType: TABLE_TYPE.GOOGLE_SHEET,
        googleSheetId: section.id,
      });
    } else {
      this.props.toggleTabAndToolPanelData({
        tabView: section.label,
        isOpen: true,
        panelView: "google-catalog",
        page: TABLE_TYPE.GOOGLE_SHEET,
        tabViewType: TABLE_TYPE.GOOGLE_SHEET,
        googleSheetId: section.id,
      });
    }
  };

  _checkTableLinkedAndSynced = (linked, synced) => {
    if (linked && synced) {
      return true;
    }
    return false;
  };

  _dropdownOptionsData = () => {
    const options = [];
    // const { connected } = this.props.section;
    const { viewMode, modesAvailable, allowModeSelection } =
      this.props.section.data.attributes;

    if (allowModeSelection && Array.isArray(modesAvailable)) {
      modesAvailable.forEach(mode => {
        const selected = (!viewMode && mode.default) || viewMode === mode.value;
        options.push({
          id: mode.value,
          name: mode.label,
          optionIcon: selected ? ["fas", "check-circle"] : null,
          optionIconColor: selected ? "#37BC72" : null,
          // action: () => mode.onChange(mode.value),
          action: e => {
            mode.onChange(mode.value);
            this._toggleDropdownHandler(e);
          },
        });
      });
    }

    return {
      icon: "link",
      iconType: "far",
      position: this.props.dataSourceForNcol ? "right" : "bottomLeft",
      title: "Choose different view",
      selectedClassNameIdent: "",
      className: "assetitem-settings-dropdown",
      options,
    };
  };

  _updateMultipleState = obj => {
    this.setState({
      ...obj,
    });
  };

  _toggleDropdownHandler = e => {
    // e.preventDefault();
    // this.props.preventEditorToDeactivate(false);
    this.props.toggleDropdown(e, "QuoteView");
    // this.props.preventEditorToDeactivate(false);
  };

  _showQuoteViewChange = () => {
    const { readOnly } = this.props;

    return !readOnly ? (
      <div
        className={`table-add-column styling-icons table-datasource-btn ${
          this.props.dataSourceForNcol ? "table-manageview" : ""
        }`}>
        <Fragment>
          <div
            ref={ele => {
              this.node = ele;
            }}
            className={`table-style-items table-datasource-icon ${
              this.props.dataSourceForNcol ? "table-datasource" : ""
            }`}>
            <Tooltip
              placement="top"
              overlay="Change view"
              align={{
                offset: [0, 3],
              }}>
              <span
                data-test="table-datasource-span"
                className={`btn-positive ${
                  this.props.dataSourceForNcol ? "link-data-source" : ""
                }`}
                onMouseDown={e => {
                  this.props.toggleDropdown(e, "QuoteView");
                }}
                role="button"
                tabIndex={0}>
                <div className="quoteview-text-ncol">Manage view</div>
                {!this.props.dataSourceForNcol && (
                  <i>
                    <FontAwesomeIcon
                      icon={[
                        "far",
                        `${
                          this.props.showQuoteViewDropdown
                            ? "angle-up"
                            : "angle-down"
                        }`,
                      ]}
                    />{" "}
                  </i>
                )}
              </span>
            </Tooltip>
            <Dropdown
              options={this._dropdownOptionsData()}
              showDropdown={this.props.showQuoteViewDropdown}
              showDropdownHandler={this._toggleDropdownHandler}
            />
          </div>
        </Fragment>
      </div>
    ) : null;
  };

  render() {
    return <Fragment>{this._showQuoteViewChange()}</Fragment>;
  }
}

const mapStateToProps = state => {
  const { activeComponentMeta } = state.DocumentStore;
  let focusRowID = null;
  let focusColumnID = null;

  const { tableRowId, tableColId } = activeComponentMeta;

  focusRowID = tableRowId !== undefined ? tableRowId : null;
  focusColumnID = tableColId !== undefined ? tableColId : null;
  const activeCell =
    focusRowID !== undefined && focusColumnID !== undefined
      ? [focusRowID, focusColumnID]
      : null;

  return {
    focusRowID,
    focusColumnID,
    activeCell,
    activeComponentMeta,
  };
};

const mapDispatchToProps = {
  preventEditorToDeactivate,
  toggleTabAndToolPanelData,
};

export default connect(mapStateToProps, mapDispatchToProps)(QuoteTableViewBtn);
